module.exports = __webpack_public_path__ + "static/media/money.305cfb73.png";